import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { typeStyle } from 'constants/typography';

/* Figma "Page title" (997:7447). */
export interface PageTitleProps {
  titleId?: string;
  title?: React.ReactNode;
  descriptionId?: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  'data-e2e'?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({
  titleId,
  title,
  descriptionId,
  description,
  actions,
  'data-e2e': dataE2e = 'page-title'
}) => (
  <Container data-e2e={dataE2e}>
    <TitleAndBody>
      <Title>{title ?? (titleId && <FormattedMessage id={titleId} />)}</Title>
      {(description || descriptionId) && (
        <Body>{description ?? (descriptionId && <FormattedMessage id={descriptionId} />)}</Body>
      )}
    </TitleAndBody>
    {actions && <RightElements>{actions}</RightElements>}
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const TitleAndBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xxs);
  max-width: 660px;
  min-width: 0;
`;

const Title = styled.h2`
  ${typeStyle.headingH2}
  color: var(--text-heading);
  margin: 0;
`;

const Body = styled.div`
  ${typeStyle.bodyMd}
  color: var(--text-body);
  /* The frames break the description into authored lines (239:26184); translations carry the \n. */
  white-space: pre-line;
`;

const RightElements = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding-left: var(--padding-xxl);
  flex-shrink: 0;
`;

export default PageTitle;
